var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 60,
    viewBox: "0 0 79 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7244 20.2772C59.3121 20.6446 59.2756 21.2767 59.643 21.6891C60.0104 22.1014 60.6425 22.1379 61.0548 21.7705L59.7244 20.2772ZM61.0548 21.7705L69.7406 14.0324L68.4102 12.5391L59.7244 20.2772L61.0548 21.7705Z",
    fill: "#BFF32F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.389 30H67.834M60.389 38.3571L69.0748 47.0238M10.1357 47.0238L18.5113 38.3571M11.3766 30H18.5113M10.1357 12.9762L18.5113 21.6429",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1683 25.3021H47.9948C48.2338 25.5189 48.7281 26.4764 48.9453 26.928C49.4885 28.0553 49.751 29.9631 49.8144 30.776C49.8796 31.0796 49.7872 32.2394 49.7329 32.7813C49.2549 35.4912 48.031 37.361 47.4788 37.9572V31.9955C47.7178 30.3262 47.0714 28.4275 46.7184 27.6868H39.0869C37.7181 27.8386 36.8146 28.9424 36.534 29.4753C35.6649 31.1663 36.1719 32.6368 36.534 33.1607C37.5117 34.83 39.1864 35.0305 39.9016 34.9221C41.7267 34.7487 42.5631 33.224 42.7532 32.4833H39.793L41.2324 30.1257H45.279V40.0438C43.9971 40.976 42.1558 41.4981 41.3953 41.6426C39.2444 41.9895 37.3125 41.4981 36.6155 41.209C34.8556 40.7104 33.3293 39.4115 32.7861 38.8243L34.6057 37.2797C36.018 38.8623 38.3445 39.3302 39.3313 39.3663C41.1563 39.453 42.5179 38.8966 42.9705 38.6076V36.1145C40.7978 37.8271 38.3536 37.352 37.403 36.9003C33.6878 35.4695 33.5013 31.7877 33.8725 30.1257C34.6329 26.3752 37.7199 25.3473 39.1683 25.3021Z",
    fill: "#BFF32F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1669 35.5182L31.3201 36.9274C29.8427 34.8462 29.6182 32.2483 29.6906 31.2096C29.582 27.7626 31.4378 25.022 32.3793 24.0826C34.704 21.4812 37.8743 20.7766 39.1688 20.7495C42.3844 20.446 45.1256 22.1767 46.0942 23.08H39.4133C31.3201 24.2913 30.7379 32.3937 33.1669 35.5182Z",
    fill: "#BFF32F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6869 9.57143C10.6869 12.0941 8.63682 14.1429 6.10323 14.1429C3.56965 14.1429 1.51953 12.0941 1.51953 9.57143C1.51953 7.04877 3.56965 5 6.10323 5C8.63682 5 10.6869 7.04877 10.6869 9.57143Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6869 30.619C10.6869 33.1417 8.63682 35.1905 6.10323 35.1905C3.56965 35.1905 1.51953 33.1417 1.51953 30.619C1.51953 28.0964 3.56965 26.0476 6.10323 26.0476C8.63682 26.0476 10.6869 28.0964 10.6869 30.619Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6869 50.4286C10.6869 52.9513 8.63682 55 6.10323 55C3.56965 55 1.51953 52.9513 1.51953 50.4286C1.51953 47.9059 3.56965 45.8572 6.10323 45.8572C8.63682 45.8572 10.6869 47.9059 10.6869 50.4286Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0707 9.57143C77.0707 12.0941 75.0206 14.1429 72.487 14.1429C69.9534 14.1429 67.9033 12.0941 67.9033 9.57143C67.9033 7.04877 69.9534 5 72.487 5C75.0206 5 77.0707 7.04877 77.0707 9.57143Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8385 31.2381C57.8385 41.2823 49.6775 49.4286 39.6058 49.4286C29.534 49.4286 21.373 41.2823 21.373 31.2381C21.373 21.1938 29.534 13.0476 39.6058 13.0476C49.6775 13.0476 57.8385 21.1938 57.8385 31.2381Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0707 30.619C77.0707 33.1417 75.0206 35.1905 72.487 35.1905C69.9534 35.1905 67.9033 33.1417 67.9033 30.619C67.9033 28.0964 69.9534 26.0476 72.487 26.0476C75.0206 26.0476 77.0707 28.0964 77.0707 30.619Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0707 50.4286C77.0707 52.9513 75.0206 55 72.487 55C69.9534 55 67.9033 52.9513 67.9033 50.4286C67.9033 47.9059 69.9534 45.8572 72.487 45.8572C75.0206 45.8572 77.0707 47.9059 77.0707 50.4286Z",
    stroke: "#BFF32F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.74340359a63564d291a826de1e67ce67.svg";
export { ForwardRef as ReactComponent };